import { getPrimaryTextClass } from "helpers/sf_utils";
import React, { useState } from "react";
import ToastAlert, { ToastAlertIconType } from "./ToastAlert/ToastAlert";
import useClearableTimeout from "hooks/useClearableTimeout";
import useFeatureFlags from "hooks/useFeatureFlags";
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";
import { UncontrolledTooltip } from "reactstrap";

export default function CopyUrl() {
  const [copied, setCopied] = useState(false);
  const [copyLinkTimeout] = useClearableTimeout();

  const [isFeatureFlagActive] = useFeatureFlags();

  if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_COPY_URL_ICON)) {
    return null;
  }

  function copy() {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
    ToastAlert.fire({ icon: ToastAlertIconType.OK, title: 'URL copied to clipboard.' })
    copyLinkTimeout(() => {
      setCopied(false)
    }, 1000)
  }

  const textClass = getPrimaryTextClass();

  return (
    <>
      <i
        style={{ cursor: "pointer", color: copied ? textClass : "" }}
        className={`fa fa-link fs-12 ms-2 ${copied ? textClass : ""}`}
        onClick={copy}
        id="copy-url"
      ></i>
      <UncontrolledTooltip placement="right" target="copy-url">
        Copy URL
      </UncontrolledTooltip>
    </>
  );
}
